const guidedFlowFeatures = {
    customFlowSystemId: undefined,
    isDeviceActivationGuideIntentAutoOpenEnabled: false,
    isGuidedFlowRecommendationEnabled: false,
    isSimplrGuideEnabled: false,
};

const workspaceCustomerFeatures = {
    isPreviousSessionSummaryEnabled: false,
};

const workspaceExpertFeatures = {
    isProactiveEnabled: false,
    isVerizonCareEnabled: false,
    isSolveLeaderboardEnabled: false,
    isOutageAlertInfoEnabled: false,
    isLightModeEnabled: false,
};

export const workspaceFeatures = {
    ...guidedFlowFeatures,
    ...workspaceCustomerFeatures,
    ...workspaceExpertFeatures,
};
